<template>
    <div class="j-gis-control-wrap" :style="positionStr">
        <div :class="['j-gis-control-item', item.class, activeCtrl === item.name && !item.clearStatus ? 'j-gis-control-active' : '', item.tag ? 'j-gis-control-tag' : '']" :key="i" v-for="(item, i) in control">
            <template v-if="item.slot">
                <div class="j-gis-control-col" @click="ctrlClick(item)">
                    <j-svg-icon v-if="item.icon" class="j-gis-control-item-icon" :name="item.icon" />
                    <span v-if="item.title" class="j-gis-control-item-text title">{{item.title}}</span>
                    <slot :name=item.name></slot>
                </div>
            </template>
            <template v-else>
                <div class="j-gis-control-col" @click="ctrlClick(item)">
                    <j-svg-icon v-if="item.icon" class="j-gis-control-item-icon" :name="item.icon" />
                    <span class="j-gis-control-item-text">{{item.name}}</span>
                </div>
                <div v-show="activeCtrl === item.name && showPopup" class="j-gis-control-popup">
                    <slot :name=item.name></slot>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
  name: 'JGisControl',
  props: {
    position: {
      type: Object,
      default () {
        return {
          top: 10,
          left: 10,
          right: 0,
          bottom: 0
        }
      }
    },
    control: {
      type: Array,
      default: () => [
        { name: '电子地图', icon: 'gis1', class: 'custom-dzdt' },
        { name: '影像地图', icon: 'gis1', class: 'custom-yxdt' },
        { name: '行政区划', icon: 'gis1', class: 'custom-xzqh' },
        { name: '测量工具', icon: 'gis1', class: 'custom-clgj' },
        { name: '筛选图层', icon: 'gis1', class: 'custom-sxtc', tag: true },
        { name: '地图居中', icon: 'gis1', class: 'custom-dtjz', clearStatus: true },
        { name: '地图搜索框', icon: 'gis1', class: 'custom-ssk', slot: true, title: '搜索框' }
      ]
    }
  },
  // computed: { // 使用计算熟悉计算定位会反复执行故使用初始化赋值
  //   positionFormat () {
  //     let style = ''
  //     for (let str in this.position) {
  //       if (!this.position[str]) continue
  //       style += `${str}:${this.position[str]}px;`
  //       console.log(str)
  //     }
  //     return style
  //   }
  // },
  data () {
    return {
      positionStr: '',
      showPopup: true,
      activeCtrl: ''
    }
  },
  created () {
    this.positionStr = this.positionFormat()
  },
  methods: {
    positionFormat () {
      let style = ''
      for (let str in this.position) {
        if (!this.position[str]) continue
        style += `${str}:${this.position[str]}px;`
        console.log(str)
      }
      return style
    },
    ctrlClick (col) {
      this.showPopup = true
      if (this.activeCtrl === col.name && !col.slot) {
        this.activeCtrl = ''
        return
      }
      this.activeCtrl = col.name
      this.$emit('change', col)
    },
    // 隐藏弹窗但不清除当前状态
    CtrlPopupHide () {
      this.activeCtrl = ''
      this.showPopup = false
    }
  }
}
</script>

<style scoped lang="scss">
    .j-gis-control-wrap {
        display: flex;
        padding: 10px;
        position: absolute;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        background-color: rgba(255,255,255,.8);

        .j-gis-control-item {
            display: flex;
            align-items: center;
            position: relative;
            color: #666;
            font-size: 12px;
            user-select: none;
            > .j-gis-control-col {
                width: 100%;
                height: 100%;
                line-height: 100%;
                display: flex;
                align-items: center;
                position: relative;
            }
            + .j-gis-control-item {
                margin-left: 20px;
            }
            cursor: pointer;
            &.j-gis-control-active {
                color: #2D76D5;
            }
            &.j-gis-control-tag {
                &::before {
                    content: '';
                    position: absolute;
                    height: 10px;
                    width: 10px;
                    right: -10px;
                    top: 2px;
                    background-color: #d93e3e;
                    border-radius: 50%;
                }
            }

            .j-gis-control-item-icon {
                font-size: 20px;
                margin-right: 4px;
            }

            .j-gis-control-item-text {
                &.title {
                    margin-right: 5px;
                }
            }

            .j-gis-control-popup {
                position: absolute;
                top: 45px;
                right: -20px;
                background-color: transparent;
            }
        }
    }
</style>
